export const FREQUENCY_DESCRIPTIONS = {
  0.0: "Don't include any logos in social posts",
  0.5: 'Include a logo in some posts. (Approximately 3-5 in every 10 posts)',
  1.0: 'Include a logo in every post',
} as const

export const CTA_FREQUENCY_DESCRIPTIONS = {
  0.0: "Don't include any call-to-action links in social posts",
  0.2: 'Add a call-to-action once in a while (Approximately 1 in every 10 posts)',
  0.5: 'Include a call-to-action in some posts (Approximately 3-5 in every 10 posts)',
  0.8: 'Add a call-to-action to most posts (Approximately 6-8 in every 10 posts)',
  1.0: 'Include a call-to-action in every post',
} as const

export const MOBILE_CTA_FREQUENCY_DESCRIPTIONS = {
  0.0: 'No links will be added to your captions. Adding links occasionally (~1 in 10 posts) performs best. Choose “Rarely” for best performance.',
  0.2: 'Add links occasionally (~1 in 10 posts). Using links too often can reduce reach. Choose “Rarely” for best performance.',
  0.5: 'Adds a link in some posts (~3-5 in 10). Using links more often can reduce reach. Choose “Rarely” for best performance.',
  0.8: 'Adds a link to most posts (~6-8 in 10). Frequent links may limit reach. Chose “Rarely” for best performance.',
  1.0: 'Adds a link in every post. Consistent external links can reduce reach. Choose “Rarely” for best performance.',
} as const

export const LOGO_FREQUENCY_OPTIONS = [
  { key: 0.0, title: 'Never' },
  { key: 0.5, title: 'Sometimes' },
  { key: 1.0, title: 'Always' },
]

export const CTA_FREQUENCY_OPTIONS = [
  { key: 0.0, title: 'Never' },
  { key: 0.2, title: 'Rarely' },
  { key: 0.5, title: 'Sometimes' },
  { key: 0.8, title: 'Often' },
  { key: 1.0, title: 'Always' },
]

export const HASHTAG_FREQUENCY_OPTIONS = [
  { key: 0.0, title: 'Never' },
  { key: 0.5, title: 'Sometimes' },
  { key: 1.0, title: 'Always' },
]

export const INCLUDE_VIDEO_IN_SOCIAL_POSTS_OPTIONS = [
  { key: 1.0, title: 'Always' },
  { key: 0.5, title: 'Sometimes' },
  { key: 0.0, title: 'Never' },
]

export const REPRESENTATION_AGE_OPTIONS = [
  { key: '18-24', title: '18-24' },
  { key: '25-34', title: '25-34' },
  { key: '35-44', title: '35-44' },
  { key: '45-54', title: '45-54' },
  { key: '55-64', title: '55-64' },
  { key: '65+', title: '65+' },
]

export const REPRESENTATION_ETHNICITY_OPTIONS = [
  { key: 'hispanic_latino', title: 'Hispanic / Latino' },
  { key: 'asian', title: 'Asian' },
  { key: 'black_african', title: 'Black / African Descent' },
  { key: 'white_caucasian', title: 'White / Caucasian' },
  { key: 'middle_eastern', title: 'Middle Eastern' },
  { key: 'multicultural_diverse', title: 'Multicultural / Diverse Group' },
]

export const RECOMMENDED_CTA_FREQUENCY = 0.2

export const RECOMMENDED_LOGO_FREQUENCY = 0.5

export const RECOMMENDED_HASHTAG_FREQUENCY = 0.5

export const RECOMMENDED_BRAND_KIT_MEDIA_REUSE_WEEKS = 3

export const NEVER_REUSE_WEEKS = 9999

// eslint-disable-next-line no-useless-escape
export const HASHTAG_DISALLOWED_REGEX = /[#\s!@$%^&*()\[\]{}|`~=+\-:;.,'"/\\?_]/g
